import React from "react";

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

const LinkifiedText = ({ text }) => (
  <>
    {String(text || "").split(URL_PATTERN).map((part, index) =>
      /^https?:\/\//.test(part) ? (
        <a key={`${part}-${index}`} href={part} target="_blank" rel="noreferrer">
          {part}
        </a>
      ) : (
        <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>
      )
    )}
  </>
);

export default LinkifiedText;
